import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProposalCard = ({ proposal, messageId, isSender, timestamp }) => {
  const [status, setStatus] = useState(proposal?.status || 'pending');

  const formatTime = (date) => {
    return new Date(date)?.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'accepted':
        return 'bg-green-500/10 text-green-600 border-green-500/20';
      case 'rejected':
        return 'bg-red-500/10 text-red-600 border-red-500/20';
      case 'pending':
      default:
        return 'bg-yellow-500/10 text-yellow-600 border-yellow-500/20';
    }
  };

  const handleAccept = () => {
    setStatus('accepted');
    // TODO: Update proposal status in database
  };

  const handleReject = () => {
    setStatus('rejected');
    // TODO: Update proposal status in database
  };

  return (
    <div className={`flex ${isSender ? 'justify-end' : 'justify-start'}`}>
      <div className="max-w-md">
        <div className="bg-card border-2 border-primary/20 rounded-lg p-4 space-y-3">
          {/* Header */}
          <div className="flex items-start justify-between gap-3">
            <div className="flex items-center gap-2">
              <Icon name="FileText" size={20} className="text-primary" />
              <h4 className="font-semibold text-foreground">Campaign Proposal</h4>
            </div>
            <span className={`text-xs px-2 py-1 rounded-full border capitalize ${getStatusColor(status)}`}>
              {status}
            </span>
          </div>

          {/* Budget */}
          {proposal?.budget && (
            <div className="flex items-center justify-between py-2 border-b border-border">
              <span className="text-sm text-muted-foreground">Budget</span>
              <span className="text-lg font-bold text-primary">${proposal?.budget?.toLocaleString()}</span>
            </div>
          )}

          {/* Deliverables */}
          {proposal?.deliverables && proposal?.deliverables?.length > 0 && (
            <div>
              <h5 className="text-sm font-medium text-foreground mb-2">Deliverables</h5>
              <ul className="space-y-1">
                {proposal?.deliverables?.map((item, index) => (
                  <li key={index} className="flex items-start gap-2 text-sm text-muted-foreground">
                    <Icon name="CheckCircle2" size={16} className="text-primary mt-0.5 flex-shrink-0" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Timeline */}
          {proposal?.timeline && (
            <div className="flex items-center gap-2 text-sm">
              <Icon name="Clock" size={16} className="text-muted-foreground" />
              <span className="text-muted-foreground">Timeline:</span>
              <span className="font-medium text-foreground">{proposal?.timeline}</span>
            </div>
          )}

          {/* Actions */}
          {!isSender && status === 'pending' && (
            <div className="flex gap-2 pt-2">
              <Button
                variant="default"
                size="sm"
                onClick={handleAccept}
                iconName="Check"
                className="flex-1"
              >
                Accept
              </Button>
              <Button
                variant="outline"
                size="sm"
                onClick={handleReject}
                iconName="X"
                className="flex-1"
              >
                Decline
              </Button>
            </div>
          )}

          {/* Timestamp */}
          <div className="text-xs text-muted-foreground text-right pt-2 border-t border-border">
            {formatTime(timestamp)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProposalCard;